import EN from "./locales/en";
import ID from "./locales/id";
import TH from "./locales/th";
import VI from "./locales/vn";

import i18next from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";

export enum CountryLanguage {
  EN = "EN",
  VI = "VI",
  ID = "ID",
  TH = "TH",
}

const savedLang =
  (localStorage.getItem("language") as CountryLanguage) || CountryLanguage.VI;

i18next.use(initReactI18next).init({
  lng: savedLang, // ✅ ngôn ngữ hiện tại
  fallbackLng: CountryLanguage.VI, // ✅ fallback khi thiếu key
  debug: false,
  resources: {
    EN: { translation: EN },
    VI: { translation: VI },
    ID: { translation: ID },
    TH: { translation: TH },
  },
  interpolation: {
    escapeValue: false,
  },
});

const changeLanguage = (value: CountryLanguage) => {
  i18next.changeLanguage(value);
  localStorage.setItem("language", value);
};

const useI18n = () => {
  const { i18n } = useTranslation();
  return i18n;
};

const useLanguage = () => {
  const { t } = useTranslation();
  return t;
};

export { useLanguage, useI18n, changeLanguage };
export default i18next;
